import { QueryClient } from 'react-query';

/**
 * Shared QueryClient instance for React Query.
 * This singleton is used by both React components (via useQueryClient hook)
 * and Zustand stores (via direct import) to share the same cache.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh for this duration
      cacheTime: 15 * 60 * 1000, // 15 minutes - unused data stays in cache
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      retry: 1, // Retry failed requests once
    },
  },
});
